'use client';

/**
 * TypingIndicator — shows an animated "thinking" state in the conversation
 * while waiting for the assistant to respond.
 *
 * Renders as a left-aligned bubble (matching assistant bubble styling)
 * with three pulsing dots. Appears immediately after the user sends a
 * message and disappears when the assistant's first content arrives.
 */

import { memo } from 'react';
import { cn } from '@/lib/utils';

interface TypingIndicatorProps {
  /** Whether the indicator should be visible */
  visible: boolean;
  className?: string;
}

export const TypingIndicator = memo(function TypingIndicator({
  visible,
  className,
}: TypingIndicatorProps) {
  if (!visible) return null;

  return (
    <div className={cn('flex justify-start', className)}>
      <div
        className={cn(
          'flex items-center gap-1 rounded-[20px] bg-white px-[20px] py-3.5',
          'border-[1px] border-[#f2f0ee] shadow-[0_1px_3px_rgba(0,0,0,0.04)]'
        )}
      >
        <span
          className="size-2 animate-bounce rounded-full bg-[#9598a6]"
          style={{ animationDelay: '0ms', animationDuration: '1s' }}
        />
        <span
          className="size-2 animate-bounce rounded-full bg-[#9598a6]"
          style={{ animationDelay: '150ms', animationDuration: '1s' }}
        />
        <span
          className="size-2 animate-bounce rounded-full bg-[#9598a6]"
          style={{ animationDelay: '300ms', animationDuration: '1s' }}
        />
      </div>
    </div>
  );
});
